import TransferOrderController from './transferorder.controller';

/**
 * this is the controller to create a new transport order
 **/
export default class TransferOrderCreateController extends TransferOrderController {
	/**
	 * define required services here, think of the defined services inside the constructor of the superclass
	 * @param {function} - $injector to inject all services
	 **/
	constructor($injector, $localStorage, $rootRouter) {
		super($injector);
		this.$rootScope = $injector.get("$rootScope");
		this.$rootRouter = $injector.get("$rootRouter");
		this.TransferOrderService = $injector.get('TransferOrderService');
		this.LocationService = $injector.get('LocationService');
		this.$window = $injector.get('$window');
		this.innerWidth = this.$window.innerWidth;

		this.OrderService = $injector.get('OrderService');
		this.moment = $injector.get('moment');
		this.$mdpTimePicker = $injector.get('$mdpTimePicker');
	}

	/**
	 * initialize the component and define some models
	 **/
	$onInit() {
		this.component = {
			title: 'Transportauftrag erstellen',
			icon: ''
		};

		this.priorityList = [
			{
				"id":1,
				"name": "niedrig"
			},
			{
				"id":2,
				"name": "normal"
			},
			{
				"id":3,
				"name": "hoch"
			}
		];

		let nowMoment = this.moment();
		this.date = nowMoment.toDate();
		this.time = {
			hour: parseInt(nowMoment.format("HH")),
			minute: parseInt(nowMoment.format("mm")),
			second: 0
		};

		this.units = this.$storage.units;
		this.searchUnitText = '';
		this.locations = this.$storage.locations;
		this.transportauftrag = this.TransferOrderService.createTransferOrderObject();
		this.datesArray = this.createDates(3);
	}

	/**
	 * add new transport good
	 **/
	addPosition() {
		let position = {
			"posNr": 0,
			"transportgutText": "",
		};
		this.transportauftrag.positionen.push(position);
	}

	/**
	 * create array with n dates
	 * @param  {int} 	quantity of dates
	 * @return {array} 	array with dates
	 */
	createDates(quantity) {
		let dates = [];

		for(let i = 1; i <= quantity; i++) {
			const date = this.moment().add(i, 'd').toDate();
			dates.push(date);
		}

		return dates;
	}

	/**
	 * remove position
	 * @param {number} - index of position inside the array
	 **/
	removePosition(posIndex) {
		if (posIndex !== 0 || Object.keys(this.transportauftrag.positionen).length > 1) {
			this.transportauftrag.positionen.splice(posIndex, 1);
		}
	}

	/**
	 * save new transport order and navigate back
	 * @return {void}
	 **/
	save() {
		// Convert and modify data before sending to the backend
		this.transportauftrag.start = this.selectedItemFrom !== null ? this.selectedItemFrom : {"name":this.searchTextFrom};
		this.transportauftrag.ziel = this.selectedItemTo !== null ? this.selectedItemTo : {"name":this.searchTextTo};

		this.transportauftrag.positionen.forEach((position, index) => {
			position.posNr = index + 1;
		});

		this.onChangeDateTime();

		const request = this.TransferOrderService.createTransferOrderCreateObject(this.transportauftrag);
		//console.log('save transportauftrag', request);

		this.TransferOrderService.saveTransferOrder(request)
			.then((response) => {
				this.ToastService.toast('Auftrag wurde erfolgreich erstellt.');
				this.$rootScope.$broadcast('menu-bar:notification:add', {
					headline: 'Transportauftrag '+response[0].transportauftrNr+' erstellt.',
					subheadline: 'Start: '+response[0].start.bez+' Ziel: '+response[0].ziel.name,
					text: 'Erstellt von '+ response[0].erstelltVon.fullname
				});
				// Navigate to the transfer order list
				this.$rootRouter.navigate(['Daisy', 'Transportauftrag', 'TransportauftragList']);
			})
			.catch((err) => {
				// this.ToastService.danger('Fehler beim Speichern des Auftrags. ' + err.statusText);
			});
	}

	querySearch(query) {
		let results = query ? this.orderNumbers.filter( this.createFilterFor(query) ) : this.orderNumbers;
		return results;
	}

	querySearchUnit(query) {
		return _.filter(this.units, (obj) => {
			return (obj.bez.toLowerCase().indexOf(query.toLowerCase()) === 0);
		});
	}

	querySearchLocation(query) {
		return _.filter(this.locations, (obj) => {
			return (obj.bez.toLowerCase().indexOf(query.toLowerCase()) === 0 || obj.nr.toLowerCase().indexOf(query.toLowerCase()) === 0);
		});
	}

	createFilterFor(query) {
		return function filterFn(number) {
			let numberAsString = number.toString();
			return (numberAsString.indexOf(query) === 0);
		};
	}

	onClickSelectDate(date) {
		this.date = date;
		this.onChangeDateTime();
	}

	onChangeDateTime() {
		const date = this.moment(this.date).format('DD.MM.YYYY');
		const time = this.getTime();
		const newDateTime = this.moment.parseZone(date+' '+time, 'DD.MM.YYYY HH:mm:ss').utc().format();
		this.transportauftrag.wunschtermin = newDateTime;
	}

	/**
	 * Get time until the order has to be finished
	 * @return {string} time in HH:mm:ss
	 */
	getTime() {
		return this.time.hour + ':' + this.time.minute + ':' + this.time.second;
	}

	/**
	 * the component is ready
	 **/
	$routerOnActivate(next, prev) {
		this.$rootScope.$broadcast('toolbar:updateTitle', this.component);
	}

	/**
	 * static method to check if the user is authenticated
	 * @param {function} - $injector to inject all services
	 * @param {string} [path="Login"] - the path to navigate to if the user is not authenticated
	 * @return {promise} with true/false
	 **/
	static $canActivate($injector, path = 'Login') {
		const $rootRouter = $injector.get('$rootRouter');
		const AuthService = $injector.get('AuthService');
		const ToastService = $injector.get('ToastService');

		return AuthService.isAuthenticated().then((response) => {
			if (response) {
				return response;
			}
			$rootRouter.navigate([path]);
			ToastService.danger('Zugriff verweigert. Bitte melden Sie sich an.');
			return false;
		}, (err) =>  {
			$rootRouter.navigate([path]);
			return false;
		});
	}

}
